//////LIBRARY//////
import React, { useEffect, useState, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cloneDeep, isEmpty, isUndefined, map, isEqual, filter, reduce, isNull, find, has } from 'lodash'
//////COMPONENTS//////
import Table from '../../components/Table'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { SalesByArticleHistoryStatus, SalesByArticleHistoryPaymentStatus } from './Components'
import { salesByArticleHistoryManagerActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import { uriList } from '../../routings/settings/RouteList'
import Theme from '../../theme/theme'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import ToggleFilters from '../../components/Ui/ToggleFilters'
import UseDatePicker from '../../hooks/UseDatePicker'
import { DatePickerFilterLabel } from '../../theme/GlobalCss'
import UseCheckAll from '../../hooks/UseCheckAll'
import userPrivileges from '../../constants/PrivilegesList'
import TooltipHelp from '../../components/TooltipHelp'
import urlExport from '../../constants/UrlExport'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Calendar from '../../assets/icones/global/calendar.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const DatePickerTransactionIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
//////STYLED//////

const SalesByArticleHistoryManager = (props) => {
	const {
		user,
		translations,
		salesByArticleHistoryManager,
		salesByArticleHistoryFilters,
		userKioskPerimeter,
		userRolePrivileges,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			translations: state.languages.translations,
			salesByArticleHistoryManager: state.salesByArticleHistoryManager,
			salesByArticleHistoryFilters: state.salesByArticleHistoryManager.header,
			user: state.user,
			userKioskPerimeter: state.user.identity.kioskSelected,
			userRolePrivileges: state.user.identity.rolePrivileges,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	let history = useHistory()

	const actionsSalesByArticleHistory = bindActionCreators(salesByArticleHistoryManagerActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)
	// Data
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'saleOrder.date', nameDir: 'desc' })

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Modals
	const [currentPerimeterKiosks, setCurrentPerimeterKiosks] = useState([])

	const [
		dateTransactionShowModal,
		dateTransactionOpenDateModalHandler,
		dateTransactionRenderModal,
		dateTransactionStateDate,
		setStartDate,
		setEndDate,
	] = UseDatePicker({
		defaultDateStart: moment().startOf('day').subtract(15, 'days').toDate(),
		defaultDateEnd: moment().hours(23).minutes(59).toDate(),
	})

	// Columns
	const [columns, setColumns] = useState([])
	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingSalesByArticleHistory = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'saleOrder.date',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'desc',
			},
		}
		setPaging(pg)
		actionsSalesByArticleHistory.getSalesByArticleHistory(handleFilterSend(), pg)
	}
	// in case of row dont have id to set inside search field we redirect like a getAll
	const handleSeeTransaction = (row) => {
		if (row.idTransaction) {
			actionsSalesByArticleHistory.setTransactionNumber(row)
			history.push(`${uriList.sales}${uriList.salesHistory}`)
		} else {
			history.push(`${uriList.sales}${uriList.salesHistory}`)
		}
	}

	const handleSeePromotion = (row) => {
		actionsSalesByArticleHistory.setPromotionNumber(row)
		history.push(`${uriList.prices}${uriList.scheduledPromoManager}`)
	}

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSelectedWithTTC = () => {
		let filtersCP = cloneDeep(filters)
		const str_filters = handleFilterSend()
		str_filters.pricesTTC = !filtersCP.pricesTTC
		str_filters.searchField = searchValue
		filtersCP.pricesTTC = !filtersCP.pricesTTC
		setFilters(filtersCP)
		actionsSalesByArticleHistory.getSalesByArticleHistory(str_filters, paging)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = { page: '0', size: '250', sort: 'saleOrder.date', nameDir: 'desc' }
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsSalesByArticleHistory.getSalesByArticleHistory(handleFilterSend(), pg)
	}

	const handleFilterSend = () => {
		// Prepping stores and kiosks selected
		// In UI, stores and kiosks are independant in listing and selection
		// But here, we need to regroup kiosks with their stores
		// {
		// 	"selectedStoreId": 4,
		// 	"selectedKiosksIds": [3,2]
		// },
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		let arr_selectedStoresKiosksIds = []
		map(filters.availableStores, (store) => {
			let rst = {}
			if (store.active) {
				rst.selectedStoreId = store.id

				// Extract kiosks
				let kiosks = map(filter(store.availableKiosks, { active: true }), 'id')
				rst.selectedKiosksIds = kiosks
			}

			if (!isEmpty(rst)) arr_selectedStoresKiosksIds.push(rst)
		})

		return {
			...filtersOut,
			withFilters: false,
			userKioskScope: {
				kiosksInLocalScope: reduce(
					user.identity.kioskSelected,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			datesRange: {
				dateStart: dateTransactionStateDate.date.startDate,
				dateEnd: dateTransactionStateDate.date.endDate,
			},
		}
	}

	/////////////////////////////// CONFIG //////////////////////////////////////

	useEffect(() => {
		setColumns([
			/*{ dataHook: 'id', headerName: '', "isAuthorize": false, component: SalesHistoryToggleNested, sortable: false },*/
			{
				columnReferential: 'saleByArticle_transactionStatus',
				dataHook: 'salesOrderStatus.translationKey',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_transactionStatus'],
				isAuthorize: true,
				sortable: true,
				component: SalesByArticleHistoryStatus,
				sortableId: 'saleOrder.status.description',
			},
			{
				columnReferential: 'saleByArticle_transactionDate',
				dataHook: 'dateCreated',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_transactionDate'],
				isAuthorize: true,
				sortable: true,
				component: (props) => moment(props.row.dateCreated).utc().format('DD/MM/YYYY HH:mm'),
				sortableId: 'saleOrder.date',
			},
			{
				columnReferential: 'saleByArticle_transactionNumber',
				dataHook: 'idTransaction',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_transactionId'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.transactionId',
			},
			{
				columnReferential: 'saleByArticle_family',
				dataHook: 'itemFamily.translationKey',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_itemFamilly'],
				isAuthorize: true,
				sortable: true,
				toTranslate: true,
				toMapObject: true,
				sortableId: 'itemKiosk.itemDistributor.item.family.label',
			},
			{
				columnReferential: 'saleByArticle_brand',
				dataHook: 'itemBrand.label',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_itemBrand'],
				isAuthorize: true,
				sortable: true,
				toMapObject: true,
				sortableId: 'itemKiosk.itemDistributor.item.brand.label',
			},
			{
				columnReferential: 'saleByArticle_articleCode',
				dataHook: 'codeItem',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_itemCode'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'itemKiosk.itemDistributor.item.labelToDisplay',
			},
			{
				columnReferential: 'saleByArticle_accessory',
				dataHook: 'isAccessory.translationKey',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_accessory'],
				isAuthorize: true,
				sortable: true,
				toTranslate: true,
				toMapObject: true,
				sortableId: 'itemKiosk.itemDistributor.item.itemType.id',
			},
			{
				columnReferential: 'saleByArticle_netWeight',
				dataHook: 'netWeight',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_netWeight'],
				isAuthorize: true,
				sortable: true,
				component: (props) => (isNull(props.row.netWeight) ? '-' : props.row.netWeight),
				sortableId: 'itemKiosk.itemDistributor.item.netWeight',
			},
			{
				columnReferential: 'saleByArticle_articleAmount',
				dataHook: 'amountItem',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_itemAmount'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.amountItem) ? `${props.row.amountItem}${props.row.currency.symbol}` : '-'),
				sortableId: 'priceItemTotalTTC',
			},
			{
				columnReferential: 'saleByArticle_articleVAT',
				dataHook: 'vatAmount',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_itemVatRateAmount'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.vatAmount) ? `${props.row.vatAmount}${props.row.currency.symbol}` : '-'),
				sortableId: 'vatAmountLineTTC',
			},
			{
				columnReferential: 'saleByArticle_consignation',
				dataHook: 'withDeposit.translationKey',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_withDeposit'],
				isAuthorize: true,
				sortable: true,
				toTranslate: true,
				toMapObject: true,
				sortableId: 'withDeposit',
			},
			{
				columnReferential: 'saleByArticle_consignationAmount',
				dataHook: 'amountDeposit',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_depositAmount'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.amountDeposit) ? `${props.row.amountDeposit}${props.row.currency.symbol}` : '-'),
				sortableId: 'priceDepositTotalTTC',
			},
			{
				columnReferential: 'saleByArticle_consignationVAT',
				dataHook: 'vatAmountDeposit',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_depositVatRateAmount'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.vatAmountDeposit) ? `${props.row.vatAmountDeposit}${props.row.currency.symbol}` : '-'),
			},
			{
				columnReferential: 'saleByArticle_promotion',
				dataHook: 'withPromo.translationKey',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_promotion'],
				isAuthorize: true,
				sortable: true,
				toTranslate: true,
				toMapObject: true,
				sortableId: 'promotionCampaign.id',
			},
			{
				columnReferential: 'saleByArticle_lockerIn',
				dataHook: 'lockerIn',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_lockerIn'],
				isAuthorize: true,
				sortable: true,
				component: (props) => (isNull(props.row.lockerIn) ? '-' : props.row.lockerIn),
				sortableId: 'labelLockerIn',
			},
			{
				columnReferential: 'saleByArticle_lockerOut',
				dataHook: 'lockerOut',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_lockerOut'],
				isAuthorize: true,
				sortable: true,
				component: (props) => (isNull(props.row.lockerOut) ? '-' : props.row.lockerOut),
				sortableId: 'labelLockerOut',
			},
			{
				columnReferential: 'saleByArticle_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_kioskCode'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'saleOrder.kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'saleByArticle_kioskName',
				dataHook: 'kioskName',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_kioskName'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'saleOrder.kiosk.description',
			},
			{
				columnReferential: 'saleByArticle_clientKioskCode',
				dataHook: 'customerKioskCode',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_kioskCodeCustomer'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'saleOrder.kiosk.labelToOwner',
			},
			{
				columnReferential: 'saleByArticle_distributor',
				dataHook: 'distributorLabelToDisplay',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_distributorLabel'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'saleOrder.distributor.company.labelToDisplay',
			},
			{
				columnReferential: 'saleByArticle_paymentType',
				dataHook: 'paymentType.translationKey',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_paymentType'],
				isAuthorize: true,
				sortable: true,
				toTranslate: true,
				toMapObject: true,
				sortableId: 'saleOrder.paymentType.label',
			},
			{
				columnReferential: 'saleByArticle_code',
				dataHook: 'code',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_salesOrderCode'],
				isAuthorize: true,
				sortable: true,
				sortableId: 'saleOrder.code',
			},
			{
				columnReferential: 'saleByArticle_paymentStatus',
				dataHook: 'paymentStatus.translationKey',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_paymentStatus'],
				isAuthorize: true,
				sortable: true,
				component: SalesByArticleHistoryPaymentStatus,
				sortableId: 'saleOrder.paymentStatus.description',
			},
			{
				columnReferential: 'saleByArticle_clientStatus',
				dataHook: 'withCustomerInfo.translationKey',
				headerName: translations['page__transactionsHistoryByItems__salesOrderByItemsTable_tableHeader_customerInfos'],
				isAuthorize: true,
				sortable: true,
				toTranslate: true,
				toMapObject: true,
				sortableId: 'saleOrder.customerLastname',
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'salesByArticle',
					paperActionsList: [
						{
							//iconDef: seeTransactionIcon,
							name: translations['tooltip__admin__global__action__salesHistory_detail'],
							translationKey: 'tooltip__admin__global__action__salesHistory_detail',
							clickAction: (row) => {
								handleSeeTransaction(row)
							},
							isVisible: (row) =>
								row.idTransaction.length > 0 &&
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[6])),
						},
						{
							//iconDef: seePromotionIcon,
							name: translations['tooltip__admin__global__action__promotion_detail'],
							translationKey: 'tooltip__admin__global__action__promotion_detail',
							clickAction: (row) => {
								handleSeePromotion(row)
							},
							isVisible: (row) =>
								row.withPromo.translationKey === translations['common__text__yes'] &&
								!isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.view[5])),
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 9,
		labelPageTable: 'saleByArticle',
	}

	const [configTableTitle, setConfigTableTitle] = useState({
		paging: {
			fnSendTo: (paging) => handlePagingSalesByArticleHistory(paging),
		},
		actions: {
			searchBarComponent: {
				handleSearchEnter: handleSearchEnter,
				handleClickSearch: handleClickSearch,
				placeholder: translations['common__text__fastFilter_search'],
				handleReset: (refInput) => {
					refInput.current.value = ''
					setSearchValue('')
				},
			},
			toggleLists: [
				() => (
					<ToggleFilters
						defaultChecked
						onChangeHandler={handleSelectedWithTTC}
						name="selectedwithTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				),
			],
			dateLists: [
				() => (
					<Fragment>
						<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
							{translations['page__global__admin__header__transactionDate']} :
						</label>
						<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
						<DatePickerFilterLabel>
							<span>
								{translations['page__global__admin__header_datePicker_from']}{' '}
								{isEqual(dateTransactionStateDate.date.startDate, {})
									? moment(new Date()).subtract(15, 'days').format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
							</span>
							<span>
								{translations['page__global__admin__header_datePicker_to']}{' '}
								{isEqual(dateTransactionStateDate.date.endDate, {})
									? moment(new Date()).format('DD/MM/YYYY HH:mm')
									: moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
							</span>
						</DatePickerFilterLabel>
					</Fragment>
				),
			],
		},
	})
	const [configTable, setConfigTable] = useState({})

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (dateTransactionStateDate.showModal) {
			actionsSalesByArticleHistory.getSalesByArticleHistory(handleFilterSend(), paging)
		}
	}, [dateTransactionShowModal])

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(salesByArticleHistoryManager) && !isUndefined(salesByArticleHistoryManager)) {
			cfg.paging = {
				totalElements: salesByArticleHistoryManager.paging.totalElements,
				totalPages: salesByArticleHistoryManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingSalesByArticleHistory(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [salesByArticleHistoryManager])

	useEffect(() => {
		setFilters(salesByArticleHistoryFilters)
		setPrevFilter(salesByArticleHistoryFilters)
	}, [translations, salesByArticleHistoryFilters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)
		cfg.name = translations['page__transactionsHistoryByItems__salesOrderByItemsTable_title']
		cfg.paging = {
			totalElements: salesByArticleHistoryManager.paging.totalElements,
			totalPages: salesByArticleHistoryManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingSalesByArticleHistory(paging),
		}
		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__global__header__filter_item']}
					data={filters.filtersSelection?.items.filterElements}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'items'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__saleByItem__tableHeader_kioskCustomerCode']}
					data={filters.filtersSelection?.kiosks.filterElements}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'kiosks'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__global__header__filter_store']}
					data={filters.filtersSelection?.stores.filterElements}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'stores'}
				/>
			),
		]
		cfg.actions.toggleLists = [
			() => (
				<TooltipHelp content={'tooltipHelp__admin__modal__body__table__filter__vatSwitch'} childrenPos={2}>
					<ToggleFilters
						checked={filters.pricesTTC}
						onChangeHandler={handleSelectedWithTTC}
						size={'large'}
						name="selectedwithTTC"
						labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
						labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
					/>
				</TooltipHelp>
			),
		]
		cfg.actions.dateLists = [
			() => (
				<Fragment>
					<label style={{ color: Theme.colors.table.body.text, marginRight: '10px', lineHeight: '32px' }}>
						{translations['page__global__admin__header__transactionDate']} :
					</label>
					<DatePickerTransactionIcon onClick={dateTransactionOpenDateModalHandler} />
					<DatePickerFilterLabel>
						<span>
							{translations['page__global__admin__header_datePicker_from']}{' '}
							{moment(dateTransactionStateDate.date.startDate).format('DD/MM/YYYY HH:mm')}
						</span>
						<span>
							{translations['page__global__admin__header_datePicker_to']}{' '}
							{moment(dateTransactionStateDate.date.endDate).format('DD/MM/YYYY HH:mm')}
						</span>
					</DatePickerFilterLabel>
				</Fragment>
			),
		]

		setConfigTableTitle(cfg)
	}, [translations, filters, dateTransactionStateDate])

	useEffect(() => {
		const cfgCp = cloneDeep(configTable)
		cfgCp.export = {
			privilege: userPrivileges.export[6],
			url: urlExport[1],
			bd: {
				filtersSelection: filters.filtersSelection,
				datesRange: { dateEnd: dateTransactionStateDate.date.endDate, dateStart: dateTransactionStateDate.date.startDate },
				searchField: searchValue,
				withFilters: true,
				pricesTTC: filters.pricesTTC,
				userKioskScope: {
					kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
				},
			},
		}

		setConfigTable(cfgCp)
	}, [translations, filters])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === salesByArticleHistoryManager.itemCatalog.label) return
		handleSubmit()
	}, [filters.searchField])

	useEffect(() => {
		return function cleanUp() {
			actionsSalesByArticleHistory.resetSalesByArticleItems()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	const [swytch, setSwytch] = useState(false)

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		const userCp = cloneDeep(user)
		const isPriceTTC = userCp.identity.isPricesTTC
		if (isUndefined(user) || isEmpty(translations)) return
		if (swytch) {
			let filtersCp
			if (!isEmpty(salesByArticleHistoryManager.itemCatalog)) {
				filtersCp = {
					withFilters: false,
					filtersSelection: filters.filtersSelection,
					searchField: salesByArticleHistoryManager.itemCatalog.label,
					pricesTTC: isPriceTTC,
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
					datesRange: {
						dateStart: moment().startOf('day').subtract(15, 'days').toDate(),
						dateEnd: moment().hours(23).minutes(59).toDate(),
					},
					searchFieldUpdated: !isEmpty(salesByArticleHistoryManager.itemCatalog.label),
				}
			} else {
				filtersCp = {
					withFilters: false,
					searchField: filters.searchField,
					pricesTTC: isPriceTTC,
					userKioskScope: {
						kiosksInLocalScope: map(user.identity.kioskSelected, 'id'),
					},
					datesRange: {
						dateStart: moment().startOf('day').subtract(15, 'days').toDate(),
						dateEnd: moment().hours(23).minutes(59).toDate(),
					},
					searchFieldUpdated: false,
				}
			}
			actionsSalesByArticleHistory.getSalesByArticleHistory(filtersCp)
			actionsColumns.setColumns([])

			setFilters(filtersCp)
		}
	}, [swytch, translations])

	useEffect(() => {
		// If we came from redirection
		// in case of redirection we use state from store inside call so we dont need to set filters here
		let filtersCP = cloneDeep(filters)
		if (!isEmpty(salesByArticleHistoryManager.itemCatalog)) {
			setSearchValue(salesByArticleHistoryManager.itemCatalog.label)
			filtersCP.searchField = salesByArticleHistoryManager.itemCatalog.label
		}

		//setFilters(filtersCP)
	}, [salesByArticleHistoryManager.itemCatalog])

	// If user is changing his perimeter, we need to make a back call
	useEffect(() => {
		if (!isEqual(userKioskPerimeter, currentPerimeterKiosks) && !isEmpty(currentPerimeterKiosks))
			actionsSalesByArticleHistory.getSalesByArticleHistory(
				{
					withFilters: false,
					pricesTTC: user.identity.isPricesTTC,
					userKioskScope: {
						kiosksInLocalScope: reduce(
							user.identity.kioskSelected,
							(result, value) => {
								result.push(value.id)
								return result
							},
							[]
						),
					},
					datesRange: {
						dateStart: moment().startOf('day').subtract(15, 'days').toDate(),
						dateEnd: moment().hours(23).minutes(59).toDate(),
					},
				},
				paging
			)
		setCurrentPerimeterKiosks(userKioskPerimeter)
		setStartDate(moment().startOf('day').subtract(15, 'days').toDate())
		setEndDate(moment().hours(23).minutes(59).toDate())
	}, [userKioskPerimeter])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={salesByArticleHistoryManager.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={salesByArticleHistoryManager.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsSalesByArticleHistory.getSalesByArticleHistory}
			/>
		)
	}, [salesByArticleHistoryManager, columns, configTable, translations, paging])

	return (
		<Fragment>
			{dateTransactionRenderModal()}
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

SalesByArticleHistoryManager.propTypes = {}

SalesByArticleHistoryManager.defaultPropTypes = {}

export default SalesByArticleHistoryManager
